import SEOHEAD from "@components/SEOHEAD";
import FloatScrollButton from "@components/ui/FloatScrollButton";
import ContactUsIc from "assets/svg/contact-us/contact-us.svg";
import Mail from "assets/svg/contact-us/mail.svg";
import Aparat from "assets/svg/contact-us/social-network/aparat.svg";
import Bale from "assets/svg/footer/baleh.svg";
import Eta from "assets/svg/contact-us/social-network/eta.svg";
import Instagram from "assets/svg/contact-us/social-network/instagram.svg";
import Linkedin from "assets/svg/contact-us/social-network/linkedin.svg";
import Telegram from "assets/svg/contact-us/social-network/telegram.svg";
import Twitter from "assets/svg/contact-us/social-network/twitter.svg";
import Youtube from "assets/svg/contact-us/social-network/youtube.svg";
import React, { FC } from "react";

const socialNetwork = [
  {
    Icon: Telegram,
    link: "https://Telegram.me/Dadbanandanalawfirm",
    color:
      "linear-gradient(270deg, rgba(54, 100, 148, 0.1) 0%, rgba(4, 128, 212, 0.1) 50%, rgba(39, 178, 188, 0.1) 100%)",
  },
  {
    Icon: Aparat,
    link: "https://www.aparat.com/dadbanandana",
    color:
      "linear-gradient(267.5deg, rgba(230, 88, 0, 0.1) 4.11%, rgba(227, 128, 30, 0.1) 50.88%, rgba(254, 189, 23, 0.1) 97.65%)",
  },
  {
    Icon: Instagram,
    link: "https://instagram.com/dadbanan",
    color:
      "linear-gradient(267.42deg, rgba(60, 20, 154, 0.1) 4.67%, rgba(152, 19, 179, 0.1) 53.73%, rgba(208, 63, 178, 0.1) 96.48%)",
  },
  {
    Icon: Twitter,
    link: "https://twitter.com/FDadbanan?s=12",
    color:
      "linear-gradient(267.36deg, rgba(66, 135, 4, 0.1) 3.01%, rgba(79, 155, 10, 0.1) 36.17%, rgba(120, 177, 66, 0.1) 65.82%, rgba(161, 206, 119, 0.1) 98.99%)",
  },
  {
    Icon: Eta,
    link: "https://eitaa.com/dadbanandana",
    color:
      "linear-gradient(267.5deg, rgba(230, 88, 0, 0.1) 4.11%, rgba(227, 128, 30, 0.1) 50.88%, rgba(254, 189, 23, 0.1) 97.65%)",
  },
  {
    Icon: Bale,
    link: "https://ble.ir/dadbanancom",
    color:
      "linear-gradient(270deg, rgba(10, 202, 155, 0.1) 0%, rgba(5, 138, 106, 0.1) 100%)",
    iconClassName: "h-12 w-12 fill-[#0aca9b]",
  },
  {
    Icon: Linkedin,
    link: "https://www.linkedin.com/company/dadbanan",
    color:
      "linear-gradient(270deg, rgba(54, 100, 148, 0.1) 0%, rgba(4, 128, 212, 0.1) 50%, rgba(39, 178, 188, 0.1) 100%)",
  },
  {
    Icon: Youtube,
    link: "https://www.youtube.com/channel/UCUf__ZN6A4BcUSaMfv7927A",
    color:
      "linear-gradient(267.5deg, rgba(230, 88, 0, 0.1) 4.11%, rgba(227, 128, 30, 0.1) 50.88%, rgba(254, 189, 23, 0.1) 97.65%)",
  },
];

const ContactUs: FC = () => {
  return (
    <>
      <SEOHEAD
        {...{
          canonical: `https://dadbanan.com/contact-us`,
          title: "تماس با ما | مؤسسه دادبانان",
          keyword: ["تماس با ما"],
          seoDescription:
            "جهت تماس با ما(مؤسسه حقوقی دادبانان) با شماره‌های زیر تماس حاصل فرمایید:  واحد آموزش و ثبت نام: ۵۵۵۰ ۵۸ ۲۲ – ۰۲۱ واحد انتشارات و سفارش کتاب: ۴۹۰۰ ۵۸ ۲۲ – ۰۲۱،   رزرو و مشاوره حضوری: ۰۱۳۷ ۵۸ ۲۲ – ۰۲۱",
        }}
      />
      <div className="py-6 md:py-10 xl:py-[60px]">
        <div className="grid w-full grid-cols-1 gap-x-5 px-10 md:px-[13.5%] xl:grid-cols-2">
          <div className="flex flex-col justify-center">
            <h1 className="mb-4 text-sm font-bold md:mb-5 md:text-lg xl:mb-[30] xl:text-xl">
              تماس با تیم دادبانان دانا
            </h1>
            <p className="text-justify text-xs !leading-relaxed md:text-base xl:text-lg">
              شما دوستان و همراهان عزیز و همیشگی مؤسسه‌ی حقوقی دادبانان
              می‌توانید برای ارتباط با ما، اطلاع از دوره‌های آموزشی، سفارش کتاب
              و یا دریافت خدمات حقوقی از هر یک از روش‌های ذکر شده استفاده
              نمایید، همکاران ما در مؤسسه‌ی حقوقی دادبانان تمام تلاش خود را
              می‌کنند تا در هر زمان پاسخگوی شما بوده و در اسرع وقت به پیام‌های
              شما در فضای مجازی پاسخ دهند. (لطفاً برای مراجعه‌ی حضوری حتماً با
              همکاران در بخش مربوطه هماهنگ فرمایید.) برای ارتباط با ما، شما
              همراهان گرامی همچنین می‌توانید با ثبت‌ نام در سایت، در خبرنامه‌ی
              دادبانان عضو شوید تا از آخرین اخبار مؤسسه‌ی حقوقی دادبانان و
              همچنین دوره‌های آموزشی مطلع شوید .
            </p>
          </div>
          <img
            loading="lazy"
            src="images/contact-us/main.png"
            alt="main"
            className="row-start-1 mb-4 h-[210px] w-full rounded object-cover drop-shadow-md md:mb-[30px] md:h-96 xl:row-start-auto xl:mb-0"
          />
        </div>
        <div className="mt-6 w-full md:mt-[60px]">
          <h2 className="hidden text-center md:block md:text-lg xl:mb-[30px] xl:text-[30px]">
            راه‌های تماس با ما{" "}
          </h2>

          <p className="mb-[30px] hidden px-10 text-center text-gray-450 md:block md:px-[13.5%] xl:mb-[30px] xl:text-lg">
            برای ارتباط با ما، شما همراهان گرامی همچنین می‌توانید با ثبت‌نام در
            سایت، در خبرنامه‌ی دادبانان عضو شوید تا از آخرین اخبار مؤسسه‌ی حقوقی
            دادبانان و همچنین دوره‌های آموزشی مطلع شوید.
          </p>
          <div className="w-full px-0 md:px-[13.5%]">
            <div className="grid w-full grid-cols-1 gap-0 md:aspect-[2/2] md:grid-cols-2 md:grid-rows-2 md:gap-3 lg:grid-cols-3 lg:grid-rows-1 lg:gap-x-5 lg:gap-y-[50px] xl:aspect-[3/1]">
              <div className="relative h-full w-full transition-all duration-300 ease-in md:hover:scale-105">
                <img
                  loading="lazy"
                  src="images/contact-us/one.jpg"
                  className="h-full w-full object-cover shadow md:rounded-lg"
                  alt="images"
                />
                <div className="absolute top-0 flex h-full w-full flex-col items-center space-y-2 p-[30px] text-center text-white xl:space-y-5">
                  <img
                    loading="lazy"
                    src="images/contact-us/location.png"
                    alt="location"
                    className="h-16 w-auto flex-none md:h-12 xl:h-20"
                  />
                  <h5 className="text-2xl font-bold">آدرس شرکت</h5>
                  <p>
                    خیابان دولت، بین دیباجی و یارمحمدی، نبش کوچه طالقانی (حافظ)،
                    ساختمان بانک اقتصاد نوین، پلاک ۱، طبقه ۲، واحد ۳
                  </p>
                </div>
              </div>
              <div className="relative h-full w-full transition-all duration-300 ease-in md:col-span-full md:col-start-1 md:row-start-1 md:hover:scale-105 xl:col-span-1 xl:col-start-auto xl:row-start-auto">
                <img
                  loading="lazy"
                  src={"images/contact-us/two.png"}
                  className="h-full w-full object-cover shadow md:rounded-lg"
                  alt="images"
                />
                <div className="absolute top-0 flex h-full w-full flex-col items-center space-y-1 p-[30px] text-center text-white xl:space-y-5">
                  <ContactUsIc className="h-16 w-auto flex-none md:h-12 xl:h-20" />
                  <h5 className="text-2xl font-bold">تلفن‌های تماس</h5>
                  <div className="space-y-2 text-sm">
                    <div className="flex flex-col space-y-1 xl:space-y-3">
                      <a href="tel:02175323000">
                        واحد آموزش و ثبت‌نام کارگاه‌ها : ۰۰۰ ۲۳ ۷۵۳ - ۰۲۱
                      </a>
                      <a href="tel:09104502525">
                        شماره همراه و واتساپ : ۲۵ ۲۵ ۴۵۰ ۰۹۱۰
                      </a>
                    </div>
                    <div className="flex flex-col space-y-1">
                      <a href="tel:02122584900">
                        واحد انتشارات و سفارش کتاب : ۰۰ ۴۹ ۵۸ ۲۲ - ۰۲۱
                      </a>
                      <a href="tel:09915050789">
                        شماره همراه و واتساپ : ۷۸۹ ۵۰ ۵۰ ۰۹۹۱
                      </a>
                    </div>
                    <div className="flex flex-col space-y-1">
                      <a href="tel:02122580137">
                        واحد مشاوره حقوقی و وکالت : ۳۷ ۰۱ ۵۸ ۲۲ - ۰۲۱
                      </a>
                      <a href="tel:09913926536">
                        شماره همراه و واتساپ : 36 65 392 0991
                      </a>
                      <a href="tel:09354979797">
                        آموزش آفلاین (دادبانان پلاس) : 97 97 497 0935
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="relative h-full w-full transition-all duration-300 ease-in md:hover:scale-105">
                <img
                  loading="lazy"
                  src={"images/contact-us/three.jpg"}
                  className="h-full w-full object-cover shadow md:rounded-lg"
                  alt="images"
                />
                <div className="absolute top-0 flex h-full w-full flex-col items-center space-y-2 p-[30px] text-center text-white xl:space-y-5">
                  <Mail className="h-16 w-auto flex-none md:h-12 xl:h-20" />
                  <h5 className="text-2xl font-bold">ایمیل دادبانان دانا</h5>
                  <a href="mailto:Dadbanandanalawfirm@gmail.com">
                    Dadbanandanalawfirm@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-[30px] mb-6 px-10 md:mb-10 md:px-[13.5%] xl:mb-[80px]">
            {/* <Map /> */}
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3236.7871721362308!2d51.45619811511443!3d35.78060398017116!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e0445f442be0f%3A0x8875e9d634b2ca85!2z2YXZiNiz2LPZhyDYrdmC2YjZgtuMINiv2KfYr9io2KfZhtin2YY!5e0!3m2!1sen!2s!4v1646731684166!5m2!1sen!2s"
              className="h-36 w-full rounded-none md:h-[251px] xl:h-[510px]"
              style={{ border: 0 }}
              loading="lazy"
            ></iframe>
          </div>
          <h2 className="mb-[30px] text-center text-sm md:text-lg xl:text-xl">
            شبکه‌های اجتماعی دادبانان
          </h2>
          <div className="mx-auto grid w-max grid-cols-4 justify-center justify-items-center gap-[10px] md:grid-cols-8 md:gap-x-5">
            {socialNetwork.map(({ Icon, color, link, iconClassName }, index) => (
              <a
                key={JSON.stringify(index)}
                target="_blank"
                rel="noreferrer"
                href={link}
                className="flex h-16 w-16 items-center justify-center md:h-20 md:w-20"
                style={{
                  background: color,
                }}
              >
                <Icon className={iconClassName || "h-10 w-10"} />
              </a>
            ))}
          </div>
        </div>
      </div>
      <FloatScrollButton />
    </>
  );
};

export default ContactUs;
